<template>
  <div>
    <list-template
      :current-page="page"
      :loading="loading"
      :search-config="searchConfig"
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      :is-download="true"
      download-text="导出数据"
      @onChangePage="changeCurrentPage"
      @onDownload="download"
      @onExportAll="download"
      @onExportData="download"
      @onReset="onReset"
      @onSearch="onSearch"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import tools from '@/utils/tools'

export default {
  _config: { route: { path: 'list', meta: { title: '列表', keepAlive: true } } },
  data() {
    return {
      loading: false,
      total: 0,
      tableData: [],
      search: {},
      searchConfig: [
        { prop: 'school_id', tag: 'select', placeholder: '筛选校区', options: [], label: 'school_name', value: 'id' },
        { prop: 'name', placeholder: '搜索菜品名称' }
      ],
      tableConfig: [
        { prop: 'school_name', label: '所属校区', width: 160 },
        { prop: 'canteen_menu_name', label: '菜单名称', width: 180 },
        { prop: 'name', label: '菜品名称', minWidth: 180 },
        { prop: 'like_num', label: '喜欢数', width: 100 },
        { prop: 'not_like_num', label: '不喜欢数', width: 110 },
        { prop: 'updated_at', label: '统计时间', width: 180 }
      ]
    }
  },
  computed: {
    ...mapState(['page'])
  },
  created() {
    this.$_axios2.get('/api/common/base-school', { params: { usage: 3 } }).then(res => {
      this.searchConfig[0].options = (res.data.data && res.data.data.school) || []
    })
  },
  mounted() {
    this.$store.commit('setPage', 1)
    this.getData()
  },
  activated() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$_axios2.get('/api/canteen-menu-statistics/index', {
        params: { page: this.page, ...this.search }
      }).then(res => {
        const data = res.data.data || {}
        this.tableData = data.list || []
        this.total = (data.page && data.page.total) || 0
      }).finally(() => { this.loading = false })
    },
    changeCurrentPage(value) {
      this.$store.commit('setPage', value)
      this.getData()
    },
    onSearch(value) {
      this.search = value || {}
      this.$store.commit('setPage', 1)
      this.getData()
    },
    onReset() {
      this.search = {}
      this.$store.commit('setPage', 1)
      this.getData()
    },
    download() {
      this.$_axios2.get('/api/canteen-menu-statistics/export', {
        params: this.search,
        responseType: 'blob'
      }).then(res => {
        tools.download('菜单统计', res.data, 'csv')
      })
    }
  }
}
</script>
